import { createTheme } from "@mui/material";
import { clubs } from "./clubs";
var DEFAULT_COLOR = "#0085BE";
export var getTheme = function (user) {
    var _a;
    var main = DEFAULT_COLOR;
    if (user === null || user === void 0 ? void 0 : user.email) {
        var key = (_a = user.email.match(/@.*/)) === null || _a === void 0 ? void 0 : _a.at(0);
        main = clubs[key].color;
    }
    return createTheme({
        palette: {
            primary: { main: main },
            info: { main: main },
        },
        typography: {
            button: {
                textTransform: "none",
            },
            fontSize: 16,
        },
    });
};
